import { jsx, Fragment, jsxs } from 'react/jsx-runtime';
import { catalogApiRef, useEntity } from '@backstage/plugin-catalog-react';
import Alert from '@material-ui/lab/Alert';
import useAsync from 'react-use/esm/useAsync';
import Box from '@material-ui/core/Box';
import { ResponseErrorPanel } from '@backstage/core-components';
import { useApi } from '@backstage/core-plugin-api';
import { catalogTranslationRef } from '../../alpha/translation.esm.js';
import { useTranslationRef } from '@backstage/core-plugin-api/alpha';

async function getRelationWarnings(entity, catalogApi) {
  const entityRefRelations = entity.relations?.map(
    (relation) => relation.targetRef
  );
  if (!entityRefRelations || entityRefRelations?.length < 1 || entityRefRelations.length > 1e3) {
    return [];
  }
  const relatedEntities = await catalogApi.getEntitiesByRefs({
    entityRefs: entityRefRelations,
    fields: ["kind", "metadata.name", "metadata.namespace"]
  });
  return entityRefRelations.filter(
    (_, index) => relatedEntities.items[index] === void 0
  );
}
async function hasRelationWarnings(entity, context) {
  const catalogApi = context.apis.get(catalogApiRef);
  if (!catalogApi) {
    throw new Error(`No implementation available for ${catalogApiRef}`);
  }
  const relatedEntitiesMissing = await getRelationWarnings(entity, catalogApi);
  return relatedEntitiesMissing.length > 0;
}
function EntityRelationWarning() {
  const { entity } = useEntity();
  const catalogApi = useApi(catalogApiRef);
  const { loading, error, value } = useAsync(async () => {
    return getRelationWarnings(entity, catalogApi);
  }, [entity, catalogApi]);
  const { t } = useTranslationRef(catalogTranslationRef);
  if (error) {
    return /* @__PURE__ */ jsx(Box, { mb: 1, children: /* @__PURE__ */ jsx(ResponseErrorPanel, { error }) });
  }
  if (loading || !value || value.length === 0) {
    return null;
  }
  return /* @__PURE__ */ jsx(Fragment, { children: /* @__PURE__ */ jsxs(Alert, { severity: "warning", style: { whiteSpace: "pre-line" }, children: [
    t("entityRelationWarningDescription"),
    " ",
    value.join(", ")
  ] }) });
}

export { EntityRelationWarning, hasRelationWarnings };
//# sourceMappingURL=EntityRelationWarning.esm.js.map
